module.exports = __webpack_public_path__ + "static/p-5-2-e5b882527680776f848f16bedfe46bf0.jpg";